export default {
	getAlert : state => index => state.alerts[index],
	findAlert : state => alert => {
		const index = state.alerts.findIndex(a => {
			return ! Object.keys(alert).some(k => {
				return ! alert[k] || alert[k] !== a[k]
			})
		})
		return -1 === index ? false : state.alerts[index]
	},
}
